import { render, staticRenderFns } from "./ImportPDFPreview.vue?vue&type=template&id=70c63b94&"
import script from "./ImportPDFPreview.vue?vue&type=script&lang=js&"
export * from "./ImportPDFPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImportPDFPreview.vue?vue&type=style&index=0&id=70c63b94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports